/** Locked combat gaits (m/s). Stamina is later — sprint is unlimited this pass. */
export const SNEAK_SPEED = 1.2;
export const WALK_SPEED = 3.2;
export const SPRINT_SPEED = 6.0;

export const GRAVITY = 9.81;
export const GRAVITY_Y = -GRAVITY;
/** Ticket lock. Apex is v² / 2g ≈ 1.49 m (~1.40). */
export const JUMP_SPEED = 5.4;
export const JUMP_APEX = (JUMP_SPEED * JUMP_SPEED) / (2 * GRAVITY);
export const COYOTE_S = 0.08;

export const ACCEL = 22;
export const BRAKE = 28;
export const LOOK_SENS = 0.0022;
export const PITCH_MIN = (-70 * Math.PI) / 180;
export const PITCH_MAX = (55 * Math.PI) / 180;
